"use strict";
// export const BACKEND_DOMAIN = 'https://localhost';
// export const API_ENDPOINT = 'kirk';
exports.__esModule = true;
// export const BACKEND_DOMAIN = 'http://localhost:5000';
// export const API_ENDPOINT = '';
// export const BACKEND_DOMAIN = 'https://localhost';
// export const API_ENDPOINT = 'kirk';
// export const BACKEND_DOMAIN = 'https://master.smartorg.com';
// export const API_ENDPOINT = 'kirk';
// export const BACKEND_DOMAIN = 'https://demos.smartorg.com/';
// export const API_ENDPOINT = 'kirk';
// export const BACKEND_DOMAIN = 'https://inav.smartorg.com';
// export const API_ENDPOINT = 'kirk';
// export const BACKEND_DOMAIN = 'https://qa.smartorg.com';
// export const API_ENDPOINT = 'kirk';
// export const BACKEND_DOMAIN = 'https://thilak.smartorg.com';
// export const API_ENDPOINT = 'kirk';git 
// export const BACKEND_DOMAIN = 'https://junaid.smartorg.com';
// export const API_ENDPOINT = 'kirk';
// export const BACKEND_DOMAIN = 'https://staging.smartorg.com';
// export const API_ENDPOINT = 'kirk';
// export const BACKEND_DOMAIN = 'https://python-upgrade.smartorg.com';
// export const API_ENDPOINT = 'kirk';
exports.BACKEND_DOMAIN = 'https://BACKEND_URL_HERE';
exports.API_ENDPOINT = 'kirk';
//OUTSIDE VM (Change IP on each boot)
// export const BACKEND_DOMAIN = 'http://192.168.52.138:5000';
// export const API_ENDPOINT = '';
//# sourceMappingURL=config.js.map


// WEBPACK FOOTER //
// ./app/config.js